export default {
  image: 'Application mon-marché',
  arrow: 'Scannez et télécharger !',
};
